import { render, staticRenderFns } from "./totalCourseList.vue?vue&type=template&id=ed6da2f4&scoped=true"
import script from "./totalCourseList.vue?vue&type=script&lang=js"
export * from "./totalCourseList.vue?vue&type=script&lang=js"
import style0 from "./totalCourseList.vue?vue&type=style&index=0&id=ed6da2f4&prod&lang=less&scoped=true"
import style1 from "./totalCourseList.vue?vue&type=style&index=1&id=ed6da2f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vue-temp_pgqv4bjfw4n43uthtcnbh5tcie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6da2f4",
  null
  
)

export default component.exports